import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ra_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Нещо се обърка. Опитайте отново.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const scrollToId = (hash) => {
  if (window.location.pathname !== "/" && window.__navigate) {
    window.__navigate(`/${hash}`);
    return;
  }
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(hash, { offset: -64 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};
